export default __webpack_public_path__ + "static/media/grant.45220443.png";